import { DataModelBuilder, SerializationContext, SerializedData } from '../../models/dto/dto.js';
import { MapUtils } from '../../utility/map-utils.js';
import { NoteComponentBase } from './note-component-base.js';

// Warning: this component should not be used in `CustomerProfile` or
// `CalendarOrderBase` classes. In these cases use `StaffNoteComponent` or
// `ClientNoteComponent` instead.
// This component can be used for example `TicketTemplate`.
export class NoteComponent extends NoteComponentBase {
  static readonly TYPE_ID: string = '1a88406fefc045a0985047f1eac60238';

  constructor(
      note: string,
  ) {
    super(note);
  }

  get $typeId(): string {
    return NoteComponent.TYPE_ID;
  }

  get $removable(): boolean {
    return true;
  }

  static fromMap(context: SerializationContext, map: SerializedData): NoteComponent {
    return new NoteComponent(
        MapUtils.get<string>(map, 'note'),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'note': this.note,
    };
  }

  clone(): this {
    return new NoteComponent(this.note) as this;
  }

  isSame(other: NoteComponent): boolean {
    if(this === other) {
      return true;
    }

    return other.note === this.note;
  }
}

export class NoteComponentBuilder extends DataModelBuilder<NoteComponent> {
  build(context: SerializationContext, map: SerializedData): NoteComponent {
    return NoteComponent.fromMap(context, map);
  }
}
